(() => {
  if (window.dfMobilePaypalReady) return;
  window.dfMobilePaypalReady = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialize = (info) => {
    if (info.dataset.dfPaypalPosition) return;
    info.dataset.dfPaypalPosition = 'true';
    const records = new Map();
    const desktopSpacing = new Map();
    const spacingProperties = ['margin-top', 'margin-bottom', 'padding-top', 'padding-bottom'];
    const compactDesktopSpacing = (message) => {
      if (mobile.matches) return;
      let node = message;
      while (node && node !== info) {
        if (!desktopSpacing.has(node)) {
          const computed = getComputedStyle(node);
          const values = spacingProperties.map((property) => ({
            property,
            value: node.style.getPropertyValue(property),
            priority: node.style.getPropertyPriority(property),
            pixels: parseFloat(computed.getPropertyValue(property))
          }));
          desktopSpacing.set(node, values);
        }
        desktopSpacing.get(node).forEach(({property, pixels}) => {
          if (Number.isFinite(pixels) && pixels > 0) node.style.setProperty(property, (pixels / 2) + 'px', 'important');
        });
        const parent = node.parentElement;
        if (!parent || parent === info || parent === slot) break;
        const otherContent = Array.from(parent.children).some((child) =>
          child !== node && !child.matches('script, style, template, input[type="hidden"]') &&
          !child.hidden && getComputedStyle(child).display !== 'none'
        );
        const otherText = Array.from(parent.childNodes).some((child) => child.nodeType === 3 && child.textContent.trim());
        if (otherContent || otherText) break;
        node = parent;
      }
    };
    let slot;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      if (!info.isConnected) { observer.disconnect(); return; }
      info.querySelectorAll('[data-pp-message]').forEach((message) => {
        if (!records.has(message) && !message.parentElement.closest('[data-pp-message]')) {
          const marker = document.createComment('paypal-original-position');
          message.before(marker);
          records.set(message, marker);
        }
      });
      if (mobile.matches) {
        desktopSpacing.forEach((values, node) => values.forEach(({property, value, priority}) => {
          if (value) node.style.setProperty(property, value, priority);
          else node.style.removeProperty(property);
        }));
        desktopSpacing.clear();
      }
      records.forEach((marker, message) => {
        if (!message.isConnected || !marker.isConnected) {
          marker.remove();
          records.delete(message);
          return;
        }
        if (mobile.matches) {
          if (!slot) {
            slot = document.createElement('div');
            slot.className = 'df-mobile-paypal-message';
            info.appendChild(slot);
          }
          if (message.parentElement !== slot) slot.appendChild(message);
        } else if (message.previousSibling !== marker) {
          marker.after(message);
        }
        compactDesktopSpacing(message);
      });
      if (slot) slot.hidden = !mobile.matches || !slot.childElementCount;
    };
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(update);
    });
    observer.observe(info, {childList: true, subtree: true});
    mobile.addEventListener('change', update);
    update();
  };
  const initializeAll = () => document.querySelectorAll('.product__info-container').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
